export default __webpack_public_path__ + "static/media/image-hero.9b5aacea.jpg";